import { render, staticRenderFns } from "./CoTestPaper.vue?vue&type=template&id=7aa04114&scoped=true&"
import script from "./CoTestPaper.vue?vue&type=script&lang=js&"
export * from "./CoTestPaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa04114",
  null
  
)

export default component.exports